const initialAction = {};

export default {
    ...initialAction,
};
